import React from 'react';
import ReactDOM from 'react-dom';

import VideoDOM_without_blob from '../videoDOM_without_blob';

class PlaylistIntro extends React.Component{

	constructor(props){
		super(props);
	}

	render(){
		return (<div className="playlist-intro">
			<VideoDOM_without_blob 
				autoplay={true}
				key={this.props.currentSong}
				ref={(video)=>{this.videoRef = video;}}
				src={_assets.root + "/video/chapter3/"+ _assets.videoSize + "/intro_tracklist.mp4"}
				timeupdate={this.props.timeupdate}
				isWaiting={this.props.isWaiting}
				ended={this.props.ended}
				isPlaying={this.props.isPlaying}
				play={this.props.play}
				pause={this.props.pause}
				poster={""} />
		</div>);
	}
}

export default PlaylistIntro;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/playlist_intro.js